import axios from 'axios';

// Récupérer tous les blogs
export const getAllBlogs = async () => {
    const response = await axios.get('/api/blogs');
    return response.data;
};

// Récupérer un blog par ID
export const getBlogById = async (id) => {
    const response = await axios.get(`/api/blogs/${id}`);
    return response.data;
};